import {AsyncSelectProps} from '../components/async-select';

export const getAsyncSelect =
  <T>(data: Omit<AsyncSelectProps<T>, 'type'>) =>
  (): AsyncSelectProps<T> => ({
    ...data,
    type: 'async-select',
  });
